module.exports = __webpack_public_path__ + "static/images/rocket.8a6799b9f6eaaa90e5184c5f1fa4b05e.svg";